import styled from "@emotion/styled";
import { indentationStep } from "../constants/sizes";

export const IndentOnce = styled.div`
  padding-left: ${indentationStep}px;
`;
